import { UserRole } from '@cdaas/api-clients/dist/asset-user-openapi';
import _ from 'lodash';

import store from './../store/configureStore';
import { removeStorageItems, setStorageItems } from './browserStorage';

const createStateString = (length: number): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const getAcrQueryParameter = (isStepUpAuthentication?: boolean): string => {
  const isCiamMfaEnabled = store.getState().featureFlags.FEATURE_FLAG_CIAM_MFA_ENABLED;

  if (isStepUpAuthentication) {
    return '&acr_values=3';
  } else if (isCiamMfaEnabled) {
    return '&acr_values=2';
  } else {
    return '';
  }
};

export const createAuthenticationUrl = (path?: string, isStepUpAuthentication?: boolean): string => {
  const state = createStateString(10);
  setStorageItems(['tState'], [{ state, path }], 'local');
  return `${process.env.REACT_APP_AUTH_SKIP_BANKID_URI}&redirect_uri=${process.env.REACT_APP_AUTH_RETURN_LINK}&state=${state}${getAcrQueryParameter(isStepUpAuthentication)}`;
};

export const getUserInitials = (fullName: string | undefined | null): string => {
  if (!fullName) {
    return '';
  }
  const names = fullName.split(' ');
  return `${names[0].charAt(0)}${names.length > 1 ? names[names.length - 1].charAt(0) : ''}`;
};

/**
 * Check whether user has at least one of the required roles.
 * @param requiredRoles Roles to check
 * @returns True if user has at least one of the required roles
 */
export const hasUserARequiredRole = (requiredRoles: UserRole[]): boolean => {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_AUTH_IGNORE_ROLES === 'true') {
    return true;
  }
  const user_roles = store.getState().authentication.user?.user_roles.effective;
  return _.intersection(user_roles, requiredRoles).length !== 0;
};

export const isSingleDevicePolicyInEffectForUser = (userType: 'oob' | 'authenticated') => {
  const policyEnabled = 'in-effect';
  if (userType === 'oob') {
    return store.getState().shop.orderOnBehalfUser.userToOrderFor?.policies?.single_device_policy === policyEnabled;
  } else {
    return store.getState().authentication.user?.policies?.single_device_policy === policyEnabled;
  }
};

export const checkIsSelectedOrganizationOwn = (ownOrganizationId?: string, selectedOrganizationId?: string): boolean => {
  return (!!ownOrganizationId && !!selectedOrganizationId && ownOrganizationId === selectedOrganizationId) || !selectedOrganizationId;
};

export const getActiveOrganizationId = (): string => {
  const selectedOrgId = store.getState().authentication.selectedOrganization?.id;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const ownOrgId = store.getState().authentication.user?.organization?.id!;

  if (!selectedOrgId) {
    return ownOrgId;
  } else if (!hasUserARequiredRole([UserRole.Admin])) {
    // If for some reason selected organization persists but user is not admin
    removeStorageItems(['tSelectedOrganization'], 'session');
    return ownOrgId;
  }

  return selectedOrgId!;
};
